import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../data/site";

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-40 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-10 mb-16 md:mb-24">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-8">
              <span className="w-10 h-px bg-[#f5e6d3]" />
              <span className="font-display text-xs uppercase tracking-[0.3em] text-[#f5e6d3]">
                Services — 003
              </span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase leading-[0.95] tracking-tight">
              What I build
              <br />
              <span className="font-editorial italic font-light normal-case lowercase text-[#f5e6d3]">
                for clients.
              </span>
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7 self-end">
            <p className="font-body text-base md:text-lg text-zinc-300 leading-relaxed max-w-md">
              Most projects fall into one of four buckets. If yours sits
              somewhere in between, that's usually the most interesting kind.
            </p>
          </div>
        </div>

        <div className="border-t border-white/10">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: i * 0.05 }}
              data-testid={`service-${s.n}`}
              className="group border-b border-white/10 py-8 md:py-10 grid md:grid-cols-12 gap-6 items-start md:items-center cursor-default hover:bg-white/[0.02] transition-colors px-2"
            >
              <div className="md:col-span-1 font-display text-sm text-zinc-500 tracking-widest">
                {s.n}
              </div>
              <div className="md:col-span-5 font-display text-3xl md:text-4xl uppercase tracking-tight group-hover:translate-x-2 transition-transform duration-500">
                {s.title}
              </div>
              <div className="md:col-span-5 font-body text-base text-zinc-400 leading-relaxed">
                {s.desc}
              </div>
              <div className="md:col-span-1 flex md:justify-end">
                <ArrowUpRight
                  size={28}
                  className="text-zinc-600 group-hover:text-[#f5e6d3] group-hover:rotate-45 transition-all duration-500"
                />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
